import { getMomentTz, MESApiService, spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import type { SawQualityCheck } from "./sawWriteRepository";

const moment = getMomentTz();

// Same check rows as the overview card, plus what a multi-line history needs.
export interface SawQualityCheckRow extends SawQualityCheck {
	AssetId: number;
	AssetName: string | null;
	ShiftId: number | null;
	ProductionDate: Date | null;
	Shift: string | null;
	Crew: string | null;
	PartNumber: string | null;
	TargetLength: number | null;
	IsReclassified: boolean;
}

type Filters = {
	assetId?: number | null;
	shiftId?: number | null;
	startDate?: string | null;
	endDate?: string | null;
};

export const getSawQualityChecksReport = async ({
	assetId,
	shiftId,
	startDate,
	endDate,
}: Filters): Promise<SawQualityCheckRow[]> => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [
		{ name: "AssetId", value: assetId ?? null },
		{ name: "ShiftId", value: shiftId ?? null },
		{ name: "StartDate", value: startDate ?? null },
		{ name: "EndDate", value: endDate ?? null },
	];
	const resp = await apiService.callV2(
		"[FAB].[GetSawQualityChecksReport]",
		parameters,
	);
	if (!resp.ok) {
		throw new Error(resp.message || "Error fetching saw quality checks");
	}
	const rows = get(resp, "data.tables[0].rows", []) as Record<
		string,
		unknown
	>[];
	return rows.map((r) => ({
		QualityCheckId: r.QualityCheckId as number,
		BundleId: (r.BundleId as number) ?? null,
		AssetId: r.AssetId as number,
		AssetName: (r.AssetName as string) ?? null,
		ShiftId: (r.ShiftId as number) ?? null,
		ProductionDate: r.ProductionDate
			? moment.utc(r.ProductionDate as string).toDate()
			: null,
		Shift: (r.Shift as string) ?? null,
		Crew: (r.Crew as string) ?? null,
		BundleBarCount: (r.BundleBarCount as number) ?? null,
		BundleStartTime: r.BundleStartTime
			? moment.utc(r.BundleStartTime as string).toDate()
			: null,
		BundleEndTime: r.BundleEndTime
			? moment.utc(r.BundleEndTime as string).toDate()
			: null,
		PartNumber: (r.PartNumber as string) ?? null,
		TargetLength: (r.TargetLength as number) ?? null,
		MinLength: (r.MinLength as number) ?? null,
		MaxLength: (r.MaxLength as number) ?? null,
		IsCutback: (r.IsCutback as boolean) ?? null,
		IsReclassified: (r.IsReclassified as boolean) ?? false,
		CheckTL: (r.CheckTL as number) ?? null,
		CheckTR: (r.CheckTR as number) ?? null,
		CheckMC: (r.CheckMC as number) ?? null,
		CheckBL: (r.CheckBL as number) ?? null,
		CheckBR: (r.CheckBR as number) ?? null,
		CheckTime: moment.utc(r.CheckTime as string).toDate(),
		CreatedBy: (r.CreatedBy as string) ?? null,
	}));
};
